import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalStatic } from '@app/base/service/modal.static';
import { ActionNoPermissionState } from './action-no-permission-state';

@Injectable({
  providedIn: 'root',
})
export class ActionNoPermissionUiService {

  private _actionNoPermissionSubject = new Subject<ActionNoPermissionState>();

  actionNoPermissionState = this._actionNoPermissionSubject.asObservable();

  constructor(
  ) { }

  show() {
    ModalStatic.open('actionNoPermission');
  }

  hide() {
    ModalStatic.close('actionNoPermission');
  }
}